var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.14 30.404a.667.667 0 0 1-.137-.404c0-1.802.028-5.89.043-7.971a2.976 2.976 0 0 1 .923-2.139c2.81-2.683 11.455-10.934 16.667-15.895.71-.677 1.867-.031 1.664.93a7447.999 7447.999 0 0 1-4.643 21.878.667.667 0 0 1-.973.442c-.953-.523-4.288-2.305-6.345-3.403a1.994 1.994 0 0 0-2.65.733 943.365 943.365 0 0 0-3.445 5.761.666.666 0 0 1-1.104.068Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.11 14.3a.667.667 0 0 1 .3-.25c5.387-2.224 21.215-8.7 27.942-11.45.532-.217.935.465.485.821-5.729 4.532-15.775 12.224-18.778 14.52a1.976 1.976 0 0 1-1.906.276c-1.947-.733-6.104-2.3-7.729-2.93a.666.666 0 0 1-.313-.988Z",
    opacity: 0.4
  })));
};
export default SvgNotifications;